@if (user$ | async; as user) {
    <div>
        <button mat-button [matMenuTriggerFor]="menu" [matTooltip]="user.email">
            <mat-icon>expand_more</mat-icon>
            <img src="{{ user.email | identicon | async }}" class="user-icon" />
        </button>
        <mat-menu #menu="matMenu">
            <div class="flex row menu-header">
                <div>
                    <img src="{{ user.email | identicon | async }}" />
                </div>
                <div class="flex column">
                    <span>{{ user.name | titlecase }}</span>
                    <span>{{ user.email }}</span>
                </div>
            </div>
            <button mat-menu-item (click)="editPreferences()">
                <mat-icon>settings</mat-icon>
                <span>Preferences</span>
            </button>
            <a mat-menu-item rel="noreferrer" target="_blank" href="https://discord.gg/WHgwEshATM">
                <mat-icon>open_in_new</mat-icon>
                <span>Join FrogEye Discord</span>
            </a>

            @if (user.hasPermission("frog_multitenant.change_clientconfig")) {
                <button mat-menu-item routerLink="/a">
                    <mat-icon>dashboard</mat-icon>
                    <span>Admin Dashboard</span>
                </button>
            }
            @if (client$ | async; as client) {
                @if (!client.is_paid) {
                    <button mat-menu-item routerLink="/pricing">
                        <mat-icon>paid</mat-icon>
                        <span>Pricing</span>
                    </button>
                }
            }
            <button mat-menu-item (click)="logout()">
                <mat-icon>logout</mat-icon>
                <span>Logout</span>
            </button>
        </mat-menu>
    </div>
}
